// @ts-nocheck
import { QueryObject, QGuidPath, QBooleanPath, QDateTimeOffsetPath, QStringPath, QNumberPath, QEnumPath, QEntityCollectionPath, QId, QGuidParam, QEntityPath, QCollectionPath, QStringCollection, QGuidCollection, QBinaryPath, QFunction, OperationReturnType, ReturnTypes, QComplexParam, QAction } from "@odata2ts/odata-query-objects";
import type { LogMessageCatalogId, LogMessageCatalogParametersId, LogMessageCatalogLanguagesId, FileId, FolderId, SegregationTagId, CategoryId, DocumentCategoryId, DocumentEntityLinkId, DocumentId, CategoryFacetId, DocumentCategoryFacetId, DocumentEntityLinkFacetId, DocumentFacetId, GetDocumentFile2Params, GetCategoriesNotAssociatedToDocument2Params, GetDocumentsLinkedToEntity2Params, GetDocumentsNotLinkedToEntities2Params, GetDocumentCategoriesDetailsAssociatedToDocument2Params, LinkCategories2Params, DeleteDocumentCategory2Params, UnlinkDocument2Params, CopyDocumentRevision2Params, CreateDocument2Params, UploadDocuments2Params, DeleteDocuments2Params, UploadRawDocument2Params, CreateLinkDocument2Params, UnlinkCategories2Params, DeleteDocumentCategories2Params, UpdateDocumentCategory2Params, CreateNewDocumentRevision2Params, DeleteDocument2Params, SetDocumentRevisionCurrent2Params, CreateDocumentCategory2Params, LinkDocument2Params, SetDocumentIcon2Params, UpdateDocument2Params, DeleteDocumentEntityLinks2Params, LockDocument2Params, UnsetDocumentRevisionCurrent2Params, SetDocumentFile2Params, UnlockDocument2Params, CopyDocumentEntityLinksFromSourceEntityListToTargetEntityList2Params, CreateExternalDocument2Params, CreateLinkExternalDocument2Params } from "./DocumentModel";
import { ApplicationLogLevelType, SegregationTagStatus, UrlSourceEnum, DocumentType } from "./DocumentModel";

export class QLogMessageCatalog extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Owner = new QStringPath(this.withPrefix("Owner"));
    public readonly LanguageCode = new QStringPath(this.withPrefix("LanguageCode"));
    public readonly ShortMessage = new QStringPath(this.withPrefix("ShortMessage"));
    public readonly LongMessage = new QStringPath(this.withPrefix("LongMessage"));
    public readonly MessageId = new QNumberPath(this.withPrefix("MessageId"));
    public readonly Level = new QEnumPath(this.withPrefix("Level"), ApplicationLogLevelType);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly LogMessageCatalogParameters = new QEntityCollectionPath(this.withPrefix("LogMessageCatalogParameters"), () => QLogMessageCatalogParameters);
    public readonly LogMessageCatalogLanguages = new QEntityCollectionPath(this.withPrefix("LogMessageCatalogLanguages"), () => QLogMessageCatalogLanguages);
}

export const qLogMessageCatalog = new QLogMessageCatalog();

export class QLogMessageCatalogId extends QId<LogMessageCatalogId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QLogMessageCatalogParameters extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ParameterKey = new QStringPath(this.withPrefix("ParameterKey"));
    public readonly ParameterType = new QStringPath(this.withPrefix("ParameterType"));
    public readonly LogMessageCatalog_Id = new QGuidPath(this.withPrefix("LogMessageCatalog_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly LogMessageCatalog = new QEntityPath(this.withPrefix("LogMessageCatalog"), () => QLogMessageCatalog);
}

export const qLogMessageCatalogParameters = new QLogMessageCatalogParameters();

export class QLogMessageCatalogParametersId extends QId<LogMessageCatalogParametersId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QLogMessageCatalogLanguages extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly LanguageCode = new QStringPath(this.withPrefix("LanguageCode"));
    public readonly ShortMessage = new QStringPath(this.withPrefix("ShortMessage"));
    public readonly LongMessage = new QStringPath(this.withPrefix("LongMessage"));
    public readonly LogMessageCatalog_Id = new QGuidPath(this.withPrefix("LogMessageCatalog_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly LogMessageCatalog = new QEntityPath(this.withPrefix("LogMessageCatalog"), () => QLogMessageCatalog);
}

export const qLogMessageCatalogLanguages = new QLogMessageCatalogLanguages();

export class QLogMessageCatalogLanguagesId extends QId<LogMessageCatalogLanguagesId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFile extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly PayloadSize = new QNumberPath(this.withPrefix("PayloadSize"));
    public readonly CreatedBy = new QStringPath(this.withPrefix("CreatedBy"));
    public readonly LastUpdatedBy = new QStringPath(this.withPrefix("LastUpdatedBy"));
    public readonly Folder_Id = new QGuidPath(this.withPrefix("Folder_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Folder = new QEntityPath(this.withPrefix("Folder"), () => QFolder);
}

export const qFile = new QFile();

export class QFileId extends QId<FileId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFolder extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly ParentFolder_Id = new QGuidPath(this.withPrefix("ParentFolder_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ParentFolder = new QEntityPath(this.withPrefix("ParentFolder"), () => QFolder);
}

export const qFolder = new QFolder();

export class QFolderId extends QId<FolderId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSegregationTag extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Color = new QStringPath(this.withPrefix("Color"));
    public readonly TagStatus = new QEnumPath(this.withPrefix("TagStatus"), SegregationTagStatus);
    public readonly IsLogRelevant = new QBooleanPath(this.withPrefix("IsLogRelevant"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
}

export const qSegregationTag = new QSegregationTag();

export class QSegregationTagId extends QId<SegregationTagId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QCategory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Document_Id = new QGuidPath(this.withPrefix("Document_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Document = new QEntityPath(this.withPrefix("Document"), () => QDocument);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QCategoryFacet);
}

export const qCategory = new QCategory();

export class QCategoryId extends QId<CategoryId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDocumentCategory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QDocumentCategoryFacet);
}

export const qDocumentCategory = new QDocumentCategory();

export class QDocumentCategoryId extends QId<DocumentCategoryId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDocumentEntityLink extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DocumentNId = new QStringPath(this.withPrefix("DocumentNId"));
    public readonly DocumentRevision = new QStringPath(this.withPrefix("DocumentRevision"));
    public readonly LinkedEntityType = new QStringPath(this.withPrefix("LinkedEntityType"));
    public readonly LinkedEntityId = new QGuidPath(this.withPrefix("LinkedEntityId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QDocumentEntityLinkFacet);
}

export const qDocumentEntityLink = new QDocumentEntityLink();

export class QDocumentEntityLinkId extends QId<DocumentEntityLinkId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDocument extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly MIMEType = new QStringPath(this.withPrefix("MIMEType"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly IconName = new QStringPath(this.withPrefix("IconName"));
    public readonly Url = new QStringPath(this.withPrefix("Url"));
    public readonly UrlSource = new QEnumPath(this.withPrefix("UrlSource"), UrlSourceEnum);
    public readonly Icon_Id_Id = new QGuidPath(this.withPrefix("Icon_Id_Id"));
    public readonly LocalFile_Id_Id = new QGuidPath(this.withPrefix("LocalFile_Id_Id"));
    public readonly RepositoryType = new QEnumPath(this.withPrefix("RepositoryType"), DocumentType);
    public readonly Category = new QEntityCollectionPath(this.withPrefix("Category"), () => QCategory);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Icon_Id = new QEntityPath(this.withPrefix("Icon_Id"), () => QFile);
    public readonly LocalFile_Id = new QEntityPath(this.withPrefix("LocalFile_Id"), () => QFile);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QDocumentFacet);
}

export const qDocument = new QDocument();

export class QDocumentId extends QId<DocumentId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QCategoryFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Category_Id = new QGuidPath(this.withPrefix("Category_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Category = new QEntityPath(this.withPrefix("Category"), () => QCategory);
}

export const qCategoryFacet = new QCategoryFacet();

export class QCategoryFacetId extends QId<CategoryFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDocumentCategoryFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DocumentCategory_Id = new QGuidPath(this.withPrefix("DocumentCategory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DocumentCategory = new QEntityPath(this.withPrefix("DocumentCategory"), () => QDocumentCategory);
}

export const qDocumentCategoryFacet = new QDocumentCategoryFacet();

export class QDocumentCategoryFacetId extends QId<DocumentCategoryFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDocumentEntityLinkFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DocumentEntityLink_Id = new QGuidPath(this.withPrefix("DocumentEntityLink_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DocumentEntityLink = new QEntityPath(this.withPrefix("DocumentEntityLink"), () => QDocumentEntityLink);
}

export const qDocumentEntityLinkFacet = new QDocumentEntityLinkFacet();

export class QDocumentEntityLinkFacetId extends QId<DocumentEntityLinkFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDocumentFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Document_Id = new QGuidPath(this.withPrefix("Document_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Document = new QEntityPath(this.withPrefix("Document"), () => QDocument);
}

export const qDocumentFacet = new QDocumentFacet();

export class QDocumentFacetId extends QId<DocumentFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExecutionError extends QueryObject {
    public readonly ErrorCode = new QNumberPath(this.withPrefix("ErrorCode"));
    public readonly ErrorMessage = new QStringPath(this.withPrefix("ErrorMessage"));
}

export const qExecutionError = new QExecutionError();

export class QPrecheckExecution extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly FullName = new QStringPath(this.withPrefix("FullName"));
    public readonly Error = new QEntityPath(this.withPrefix("Error"), () => QExecutionError);
}

export const qPrecheckExecution = new QPrecheckExecution();

export class QSitUafExecutionDetail extends QueryObject {
    public readonly PrecheckDetails = new QEntityCollectionPath(this.withPrefix("PrecheckDetails"), () => QPrecheckExecution);
}

export const qSitUafExecutionDetail = new QSitUafExecutionDetail();

export class QCommandResponse extends QueryObject {
    public readonly Succeeded = new QBooleanPath(this.withPrefix("Succeeded"));
    public readonly Error = new QEntityPath(this.withPrefix("Error"), () => QExecutionError);
    public readonly SitUafExecutionDetail = new QEntityPath(this.withPrefix("SitUafExecutionDetail"), () => QSitUafExecutionDetail);
}

export const qCommandResponse = new QCommandResponse();

export class QFunctionResponse extends QCommandResponse {
}

export const qFunctionResponse = new QFunctionResponse();

export class QPreCheckResponse extends QCommandResponse {
}

export const qPreCheckResponse = new QPreCheckResponse();

export class QServiceLayerUnityError extends QueryObject {
    public readonly commandcallstack = new QCollectionPath(this.withPrefix("commandcallstack"), () => QStringCollection);
    public readonly stacktrace = new QStringPath(this.withPrefix("stacktrace"));
}

export const qServiceLayerUnityError = new QServiceLayerUnityError();

export class QServiceLayerErrorObject extends QueryObject {
    public readonly code = new QStringPath(this.withPrefix("code"));
    public readonly message = new QStringPath(this.withPrefix("message"));
    public readonly innererror = new QEntityPath(this.withPrefix("innererror"), () => QServiceLayerUnityError);
}

export const qServiceLayerErrorObject = new QServiceLayerErrorObject();

export class QServiceLayerError extends QueryObject {
    public readonly error = new QEntityPath(this.withPrefix("error"), () => QServiceLayerErrorObject);
}

export const qServiceLayerError = new QServiceLayerError();

export class QLinkCategoriesResponse extends QCommandResponse {
    public readonly CategoryIds = new QCollectionPath(this.withPrefix("CategoryIds"), () => QGuidCollection);
}

export const qLinkCategoriesResponse = new QLinkCategoriesResponse();

export class QLinkCategories extends QueryObject {
    public readonly DocumentId = new QGuidPath(this.withPrefix("DocumentId"));
    public readonly DocumentCategoryNIds = new QCollectionPath(this.withPrefix("DocumentCategoryNIds"), () => QStringCollection);
}

export const qLinkCategories = new QLinkCategories();

export class QDeleteDocumentCategoryResponse extends QCommandResponse {
}

export const qDeleteDocumentCategoryResponse = new QDeleteDocumentCategoryResponse();

export class QDeleteDocumentCategory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteDocumentCategory = new QDeleteDocumentCategory();

export class QUnlinkDocumentResponse extends QCommandResponse {
}

export const qUnlinkDocumentResponse = new QUnlinkDocumentResponse();

export class QUnlinkDocument extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUnlinkDocument = new QUnlinkDocument();

export class QCopyDocumentRevisionResponse extends QCommandResponse {
    public readonly DocumentId = new QGuidPath(this.withPrefix("DocumentId"));
}

export const qCopyDocumentRevisionResponse = new QCopyDocumentRevisionResponse();

export class QCopyDocumentRevision extends QueryObject {
    public readonly SourceNId = new QStringPath(this.withPrefix("SourceNId"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly TargetNId = new QStringPath(this.withPrefix("TargetNId"));
    public readonly TargetRevision = new QStringPath(this.withPrefix("TargetRevision"));
}

export const qCopyDocumentRevision = new QCopyDocumentRevision();

export class QCreateDocumentResponse extends QCommandResponse {
    public readonly DocumentId = new QGuidPath(this.withPrefix("DocumentId"));
}

export const qCreateDocumentResponse = new QCreateDocumentResponse();

export class QCreateDocument extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly RepositoryType = new QEnumPath(this.withPrefix("RepositoryType"), DocumentType);
    public readonly Icon = new QEntityPath(this.withPrefix("Icon"), () => QFileType);
    public readonly LocalFile = new QEntityPath(this.withPrefix("LocalFile"), () => QFileType);
    public readonly CategoryNIds = new QCollectionPath(this.withPrefix("CategoryNIds"), () => QStringCollection);
}

export const qCreateDocument = new QCreateDocument();

export class QUploadDocumentsResponse extends QCommandResponse {
    public readonly UploadedFileIds = new QCollectionPath(this.withPrefix("UploadedFileIds"), () => QGuidCollection);
    public readonly NotUploadedFileIds = new QCollectionPath(this.withPrefix("NotUploadedFileIds"), () => QGuidCollection);
}

export const qUploadDocumentsResponse = new QUploadDocumentsResponse();

export class QUploadDocuments extends QueryObject {
    public readonly FileIds = new QCollectionPath(this.withPrefix("FileIds"), () => QGuidCollection);
    public readonly ProjectName = new QStringPath(this.withPrefix("ProjectName"));
    public readonly FolderName = new QStringPath(this.withPrefix("FolderName"));
}

export const qUploadDocuments = new QUploadDocuments();

export class QDeleteDocumentsResponse extends QCommandResponse {
    public readonly NotDeletedIds = new QCollectionPath(this.withPrefix("NotDeletedIds"), () => QGuidCollection);
}

export const qDeleteDocumentsResponse = new QDeleteDocumentsResponse();

export class QDeleteDocuments extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteDocuments = new QDeleteDocuments();

export class QUploadRawDocumentResponse extends QCommandResponse {
}

export const qUploadRawDocumentResponse = new QUploadRawDocumentResponse();

export class QUploadRawDocument extends QueryObject {
    public readonly Payload = new QBinaryPath(this.withPrefix("Payload"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly ProjectName = new QStringPath(this.withPrefix("ProjectName"));
    public readonly FolderName = new QStringPath(this.withPrefix("FolderName"));
}

export const qUploadRawDocument = new QUploadRawDocument();

export class QCreateLinkDocumentResponse extends QCommandResponse {
    public readonly DocumentEntityLinkId = new QGuidPath(this.withPrefix("DocumentEntityLinkId"));
}

export const qCreateLinkDocumentResponse = new QCreateLinkDocumentResponse();

export class QCreateLinkDocument extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly RepositoryType = new QEnumPath(this.withPrefix("RepositoryType"), DocumentType);
    public readonly Icon = new QEntityPath(this.withPrefix("Icon"), () => QFileType);
    public readonly LocalFile = new QEntityPath(this.withPrefix("LocalFile"), () => QFileType);
    public readonly CategoryNIds = new QCollectionPath(this.withPrefix("CategoryNIds"), () => QStringCollection);
    public readonly LinkedEntityId = new QGuidPath(this.withPrefix("LinkedEntityId"));
    public readonly LinkedEntityType = new QStringPath(this.withPrefix("LinkedEntityType"));
}

export const qCreateLinkDocument = new QCreateLinkDocument();

export class QUnlinkCategoriesResponse extends QCommandResponse {
}

export const qUnlinkCategoriesResponse = new QUnlinkCategoriesResponse();

export class QUnlinkCategories extends QueryObject {
    public readonly DocumentId = new QGuidPath(this.withPrefix("DocumentId"));
    public readonly CategoryIds = new QCollectionPath(this.withPrefix("CategoryIds"), () => QGuidCollection);
}

export const qUnlinkCategories = new QUnlinkCategories();

export class QDeleteDocumentCategoriesResponse extends QCommandResponse {
    public readonly NotDeletedIds = new QCollectionPath(this.withPrefix("NotDeletedIds"), () => QGuidCollection);
}

export const qDeleteDocumentCategoriesResponse = new QDeleteDocumentCategoriesResponse();

export class QDeleteDocumentCategories extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteDocumentCategories = new QDeleteDocumentCategories();

export class QUpdateDocumentCategoryResponse extends QCommandResponse {
}

export const qUpdateDocumentCategoryResponse = new QUpdateDocumentCategoryResponse();

export class QUpdateDocumentCategory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qUpdateDocumentCategory = new QUpdateDocumentCategory();

export class QCreateNewDocumentRevisionResponse extends QCommandResponse {
    public readonly NewDocumentRevisionId = new QGuidPath(this.withPrefix("NewDocumentRevisionId"));
}

export const qCreateNewDocumentRevisionResponse = new QCreateNewDocumentRevisionResponse();

export class QCreateNewDocumentRevision extends QueryObject {
    public readonly SourceNId = new QStringPath(this.withPrefix("SourceNId"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly TargetRevision = new QStringPath(this.withPrefix("TargetRevision"));
}

export const qCreateNewDocumentRevision = new QCreateNewDocumentRevision();

export class QDeleteDocumentResponse extends QCommandResponse {
}

export const qDeleteDocumentResponse = new QDeleteDocumentResponse();

export class QDeleteDocument extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteDocument = new QDeleteDocument();

export class QSetDocumentRevisionCurrentResponse extends QCommandResponse {
}

export const qSetDocumentRevisionCurrentResponse = new QSetDocumentRevisionCurrentResponse();

export class QSetDocumentRevisionCurrent extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qSetDocumentRevisionCurrent = new QSetDocumentRevisionCurrent();

export class QCreateDocumentCategoryResponse extends QCommandResponse {
    public readonly DocumentCategoryId = new QGuidPath(this.withPrefix("DocumentCategoryId"));
}

export const qCreateDocumentCategoryResponse = new QCreateDocumentCategoryResponse();

export class QCreateDocumentCategory extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qCreateDocumentCategory = new QCreateDocumentCategory();

export class QLinkDocumentResponse extends QCommandResponse {
    public readonly DocumentEntityLinkId = new QGuidPath(this.withPrefix("DocumentEntityLinkId"));
}

export const qLinkDocumentResponse = new QLinkDocumentResponse();

export class QLinkDocument extends QueryObject {
    public readonly DocumentNId = new QStringPath(this.withPrefix("DocumentNId"));
    public readonly DocumentRevision = new QStringPath(this.withPrefix("DocumentRevision"));
    public readonly LinkedEntityId = new QGuidPath(this.withPrefix("LinkedEntityId"));
    public readonly LinkedEntityType = new QStringPath(this.withPrefix("LinkedEntityType"));
}

export const qLinkDocument = new QLinkDocument();

export class QSetDocumentIconResponse extends QCommandResponse {
}

export const qSetDocumentIconResponse = new QSetDocumentIconResponse();

export class QSetDocumentIcon extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NewIcon = new QEntityPath(this.withPrefix("NewIcon"), () => QFileType);
}

export const qSetDocumentIcon = new QSetDocumentIcon();

export class QUpdateDocumentResponse extends QCommandResponse {
}

export const qUpdateDocumentResponse = new QUpdateDocumentResponse();

export class QUpdateDocument extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Url = new QStringPath(this.withPrefix("Url"));
}

export const qUpdateDocument = new QUpdateDocument();

export class QDeleteDocumentEntityLinksResponse extends QCommandResponse {
}

export const qDeleteDocumentEntityLinksResponse = new QDeleteDocumentEntityLinksResponse();

export class QDeleteDocumentEntityLinks extends QueryObject {
    public readonly LinkedEntityId = new QGuidPath(this.withPrefix("LinkedEntityId"));
    public readonly LinkedEntityType = new QStringPath(this.withPrefix("LinkedEntityType"));
}

export const qDeleteDocumentEntityLinks = new QDeleteDocumentEntityLinks();

export class QLockDocumentResponse extends QCommandResponse {
}

export const qLockDocumentResponse = new QLockDocumentResponse();

export class QLockDocument extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qLockDocument = new QLockDocument();

export class QUnsetDocumentRevisionCurrentResponse extends QCommandResponse {
}

export const qUnsetDocumentRevisionCurrentResponse = new QUnsetDocumentRevisionCurrentResponse();

export class QUnsetDocumentRevisionCurrent extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUnsetDocumentRevisionCurrent = new QUnsetDocumentRevisionCurrent();

export class QSetDocumentFileResponse extends QCommandResponse {
}

export const qSetDocumentFileResponse = new QSetDocumentFileResponse();

export class QSetDocumentFile extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NewFile = new QEntityPath(this.withPrefix("NewFile"), () => QFileType);
}

export const qSetDocumentFile = new QSetDocumentFile();

export class QUnlockDocumentResponse extends QCommandResponse {
}

export const qUnlockDocumentResponse = new QUnlockDocumentResponse();

export class QUnlockDocument extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUnlockDocument = new QUnlockDocument();

export class QCopyDocumentEntityLinksFromSourceEntityListToTargetEntityListResponse extends QCommandResponse {
}

export const qCopyDocumentEntityLinksFromSourceEntityListToTargetEntityListResponse = new QCopyDocumentEntityLinksFromSourceEntityListToTargetEntityListResponse();

export class QCopyDocumentEntityLinksFromSourceEntityListToTargetEntityList extends QueryObject {
    public readonly EntityLinkToCopyParameterTypes = new QEntityCollectionPath(this.withPrefix("EntityLinkToCopyParameterTypes"), () => QEntityLinkToCopyParameterType);
}

export const qCopyDocumentEntityLinksFromSourceEntityListToTargetEntityList = new QCopyDocumentEntityLinksFromSourceEntityListToTargetEntityList();

export class QCreateExternalDocumentResponse extends QCommandResponse {
    public readonly DocumentId = new QGuidPath(this.withPrefix("DocumentId"));
}

export const qCreateExternalDocumentResponse = new QCreateExternalDocumentResponse();

export class QCreateExternalDocument extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly Icon = new QEntityPath(this.withPrefix("Icon"), () => QFileType);
    public readonly CategoryNIds = new QCollectionPath(this.withPrefix("CategoryNIds"), () => QStringCollection);
    public readonly Url = new QStringPath(this.withPrefix("Url"));
    public readonly UrlSource = new QEnumPath(this.withPrefix("UrlSource"), UrlSourceEnum);
}

export const qCreateExternalDocument = new QCreateExternalDocument();

export class QCreateLinkExternalDocumentResponse extends QCommandResponse {
    public readonly DocumentEntityLinkId = new QGuidPath(this.withPrefix("DocumentEntityLinkId"));
}

export const qCreateLinkExternalDocumentResponse = new QCreateLinkExternalDocumentResponse();

export class QCreateLinkExternalDocument extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly Icon = new QEntityPath(this.withPrefix("Icon"), () => QFileType);
    public readonly CategoryNIds = new QCollectionPath(this.withPrefix("CategoryNIds"), () => QStringCollection);
    public readonly LinkedEntityId = new QGuidPath(this.withPrefix("LinkedEntityId"));
    public readonly LinkedEntityType = new QStringPath(this.withPrefix("LinkedEntityType"));
    public readonly UrlSource = new QEnumPath(this.withPrefix("UrlSource"), UrlSourceEnum);
    public readonly Url = new QStringPath(this.withPrefix("Url"));
}

export const qCreateLinkExternalDocument = new QCreateLinkExternalDocument();

export class QFileType extends QueryObject {
    public readonly contents = new QStringPath(this.withPrefix("contents"));
    public readonly name = new QStringPath(this.withPrefix("name"));
    public readonly type = new QStringPath(this.withPrefix("type"));
    public readonly data = new QStringPath(this.withPrefix("data"));
}

export const qFileType = new QFileType();

export class QEntityLinkToCopyParameterType extends QueryObject {
    public readonly SourceLinkedEntityId = new QGuidPath(this.withPrefix("SourceLinkedEntityId"));
    public readonly SourceLinkedEntityType = new QStringPath(this.withPrefix("SourceLinkedEntityType"));
    public readonly TargetLinkedEntityId = new QGuidPath(this.withPrefix("TargetLinkedEntityId"));
    public readonly TargetLinkedEntityType = new QStringPath(this.withPrefix("TargetLinkedEntityType"));
}

export const qEntityLinkToCopyParameterType = new QEntityLinkToCopyParameterType();

export class QGetDocumentFileResponse extends QueryObject {
    public readonly File = new QEntityPath(this.withPrefix("File"), () => QFileType);
    public readonly Icon = new QEntityPath(this.withPrefix("Icon"), () => QFileType);
}

export const qGetDocumentFileResponse = new QGetDocumentFileResponse();

export class QGetDocumentFile extends QueryObject {
    public readonly FileId = new QGuidPath(this.withPrefix("FileId"));
    public readonly IconId = new QGuidPath(this.withPrefix("IconId"));
}

export const qGetDocumentFile = new QGetDocumentFile();

export class QGetCategoriesNotAssociatedToDocumentResponse extends QueryObject {
    public readonly DocumentCategoryNId = new QStringPath(this.withPrefix("DocumentCategoryNId"));
    public readonly DocumentCategoryName = new QStringPath(this.withPrefix("DocumentCategoryName"));
    public readonly DocumentCategoryDescription = new QStringPath(this.withPrefix("DocumentCategoryDescription"));
}

export const qGetCategoriesNotAssociatedToDocumentResponse = new QGetCategoriesNotAssociatedToDocumentResponse();

export class QGetCategoriesNotAssociatedToDocument extends QueryObject {
    public readonly DocumentId = new QGuidPath(this.withPrefix("DocumentId"));
}

export const qGetCategoriesNotAssociatedToDocument = new QGetCategoriesNotAssociatedToDocument();

export class QGetDocumentsLinkedToEntityResponse extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly MIMEType = new QStringPath(this.withPrefix("MIMEType"));
    public readonly IconId = new QGuidPath(this.withPrefix("IconId"));
    public readonly RepositoryType = new QEnumPath(this.withPrefix("RepositoryType"), DocumentType);
    public readonly LocalFileId = new QGuidPath(this.withPrefix("LocalFileId"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly IconName = new QStringPath(this.withPrefix("IconName"));
    public readonly EntityLinkId = new QGuidPath(this.withPrefix("EntityLinkId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
}

export const qGetDocumentsLinkedToEntityResponse = new QGetDocumentsLinkedToEntityResponse();

export class QGetDocumentsLinkedToEntity extends QueryObject {
    public readonly EntityId = new QGuidPath(this.withPrefix("EntityId"));
}

export const qGetDocumentsLinkedToEntity = new QGetDocumentsLinkedToEntity();

export class QGetDocumentsNotLinkedToEntitiesResponse extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly IconName = new QStringPath(this.withPrefix("IconName"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly IconId = new QGuidPath(this.withPrefix("IconId"));
    public readonly LocalFileId = new QGuidPath(this.withPrefix("LocalFileId"));
    public readonly RepositoryType = new QEnumPath(this.withPrefix("RepositoryType"), DocumentType);
    public readonly MIMEType = new QStringPath(this.withPrefix("MIMEType"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
}

export const qGetDocumentsNotLinkedToEntitiesResponse = new QGetDocumentsNotLinkedToEntitiesResponse();

export class QGetDocumentsNotLinkedToEntities extends QueryObject {
}

export const qGetDocumentsNotLinkedToEntities = new QGetDocumentsNotLinkedToEntities();

export class QGetDocumentCategoriesDetailsAssociatedToDocumentResponse extends QueryObject {
    public readonly DocumentCategoryName = new QStringPath(this.withPrefix("DocumentCategoryName"));
    public readonly DocumentCategoryDescription = new QStringPath(this.withPrefix("DocumentCategoryDescription"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qGetDocumentCategoriesDetailsAssociatedToDocumentResponse = new QGetDocumentCategoriesDetailsAssociatedToDocumentResponse();

export class QGetDocumentCategoriesDetailsAssociatedToDocument extends QueryObject {
    public readonly DocumentId = new QGuidPath(this.withPrefix("DocumentId"));
}

export const qGetDocumentCategoriesDetailsAssociatedToDocument = new QGetDocumentCategoriesDetailsAssociatedToDocument();

export class QIQueryable extends QueryObject {
}

export const qIQueryable = new QIQueryable();

export class QBaseResponse extends QCommandResponse {
}

export const qBaseResponse = new QBaseResponse();

export class QGetDocumentFile2 extends QFunction<GetDocumentFile2Params> {
    private readonly params = [new QComplexParam("function", new QGetDocumentFile())];

    constructor() {
        super("GetDocumentFile", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QGetCategoriesNotAssociatedToDocument2 extends QFunction<GetCategoriesNotAssociatedToDocument2Params> {
    private readonly params = [new QComplexParam("function", new QGetCategoriesNotAssociatedToDocument())];

    constructor() {
        super("GetCategoriesNotAssociatedToDocument", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QGetDocumentsLinkedToEntity2 extends QFunction<GetDocumentsLinkedToEntity2Params> {
    private readonly params = [new QComplexParam("function", new QGetDocumentsLinkedToEntity())];

    constructor() {
        super("GetDocumentsLinkedToEntity", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QGetDocumentsNotLinkedToEntities2 extends QFunction<GetDocumentsNotLinkedToEntities2Params> {
    private readonly params = [new QComplexParam("function", new QGetDocumentsNotLinkedToEntities())];

    constructor() {
        super("GetDocumentsNotLinkedToEntities", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QGetDocumentCategoriesDetailsAssociatedToDocument2 extends QFunction<GetDocumentCategoriesDetailsAssociatedToDocument2Params> {
    private readonly params = [new QComplexParam("function", new QGetDocumentCategoriesDetailsAssociatedToDocument())];

    constructor() {
        super("GetDocumentCategoriesDetailsAssociatedToDocument", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkCategories2 extends QAction<LinkCategories2Params> {
    private readonly params = [new QComplexParam("command", new QLinkCategories())];

    constructor() {
        super("LinkCategories", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkCategoriesResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteDocumentCategory2 extends QAction<DeleteDocumentCategory2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteDocumentCategory())];

    constructor() {
        super("DeleteDocumentCategory", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteDocumentCategoryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkDocument2 extends QAction<UnlinkDocument2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkDocument())];

    constructor() {
        super("UnlinkDocument", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkDocumentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCopyDocumentRevision2 extends QAction<CopyDocumentRevision2Params> {
    private readonly params = [new QComplexParam("command", new QCopyDocumentRevision())];

    constructor() {
        super("CopyDocumentRevision", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCopyDocumentRevisionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateDocument2 extends QAction<CreateDocument2Params> {
    private readonly params = [new QComplexParam("command", new QCreateDocument())];

    constructor() {
        super("CreateDocument", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateDocumentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUploadDocuments2 extends QAction<UploadDocuments2Params> {
    private readonly params = [new QComplexParam("command", new QUploadDocuments())];

    constructor() {
        super("UploadDocuments", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUploadDocumentsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteDocuments2 extends QAction<DeleteDocuments2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteDocuments())];

    constructor() {
        super("DeleteDocuments", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteDocumentsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUploadRawDocument2 extends QAction<UploadRawDocument2Params> {
    private readonly params = [new QComplexParam("command", new QUploadRawDocument())];

    constructor() {
        super("UploadRawDocument", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUploadRawDocumentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateLinkDocument2 extends QAction<CreateLinkDocument2Params> {
    private readonly params = [new QComplexParam("command", new QCreateLinkDocument())];

    constructor() {
        super("CreateLinkDocument", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateLinkDocumentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkCategories2 extends QAction<UnlinkCategories2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkCategories())];

    constructor() {
        super("UnlinkCategories", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkCategoriesResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteDocumentCategories2 extends QAction<DeleteDocumentCategories2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteDocumentCategories())];

    constructor() {
        super("DeleteDocumentCategories", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteDocumentCategoriesResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateDocumentCategory2 extends QAction<UpdateDocumentCategory2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateDocumentCategory())];

    constructor() {
        super("UpdateDocumentCategory", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateDocumentCategoryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNewDocumentRevision2 extends QAction<CreateNewDocumentRevision2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNewDocumentRevision())];

    constructor() {
        super("CreateNewDocumentRevision", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNewDocumentRevisionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteDocument2 extends QAction<DeleteDocument2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteDocument())];

    constructor() {
        super("DeleteDocument", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteDocumentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetDocumentRevisionCurrent2 extends QAction<SetDocumentRevisionCurrent2Params> {
    private readonly params = [new QComplexParam("command", new QSetDocumentRevisionCurrent())];

    constructor() {
        super("SetDocumentRevisionCurrent", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetDocumentRevisionCurrentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateDocumentCategory2 extends QAction<CreateDocumentCategory2Params> {
    private readonly params = [new QComplexParam("command", new QCreateDocumentCategory())];

    constructor() {
        super("CreateDocumentCategory", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateDocumentCategoryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkDocument2 extends QAction<LinkDocument2Params> {
    private readonly params = [new QComplexParam("command", new QLinkDocument())];

    constructor() {
        super("LinkDocument", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkDocumentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetDocumentIcon2 extends QAction<SetDocumentIcon2Params> {
    private readonly params = [new QComplexParam("command", new QSetDocumentIcon())];

    constructor() {
        super("SetDocumentIcon", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetDocumentIconResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateDocument2 extends QAction<UpdateDocument2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateDocument())];

    constructor() {
        super("UpdateDocument", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateDocumentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteDocumentEntityLinks2 extends QAction<DeleteDocumentEntityLinks2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteDocumentEntityLinks())];

    constructor() {
        super("DeleteDocumentEntityLinks", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteDocumentEntityLinksResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLockDocument2 extends QAction<LockDocument2Params> {
    private readonly params = [new QComplexParam("command", new QLockDocument())];

    constructor() {
        super("LockDocument", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLockDocumentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnsetDocumentRevisionCurrent2 extends QAction<UnsetDocumentRevisionCurrent2Params> {
    private readonly params = [new QComplexParam("command", new QUnsetDocumentRevisionCurrent())];

    constructor() {
        super("UnsetDocumentRevisionCurrent", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnsetDocumentRevisionCurrentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetDocumentFile2 extends QAction<SetDocumentFile2Params> {
    private readonly params = [new QComplexParam("command", new QSetDocumentFile())];

    constructor() {
        super("SetDocumentFile", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetDocumentFileResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlockDocument2 extends QAction<UnlockDocument2Params> {
    private readonly params = [new QComplexParam("command", new QUnlockDocument())];

    constructor() {
        super("UnlockDocument", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlockDocumentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCopyDocumentEntityLinksFromSourceEntityListToTargetEntityList2 extends QAction<CopyDocumentEntityLinksFromSourceEntityListToTargetEntityList2Params> {
    private readonly params = [new QComplexParam("command", new QCopyDocumentEntityLinksFromSourceEntityListToTargetEntityList())];

    constructor() {
        super("CopyDocumentEntityLinksFromSourceEntityListToTargetEntityList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCopyDocumentEntityLinksFromSourceEntityListToTargetEntityListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateExternalDocument2 extends QAction<CreateExternalDocument2Params> {
    private readonly params = [new QComplexParam("command", new QCreateExternalDocument())];

    constructor() {
        super("CreateExternalDocument", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateExternalDocumentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateLinkExternalDocument2 extends QAction<CreateLinkExternalDocument2Params> {
    private readonly params = [new QComplexParam("command", new QCreateLinkExternalDocument())];

    constructor() {
        super("CreateLinkExternalDocument", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateLinkExternalDocumentResponse)))
    }

    getParams() {
        return this.params
    }
}
